app.service("ProductStockService", ['$rootScope', 'ProductService', function ($rootScope, ProductService) {

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const regexSquareBrackets = new RegExp(/\[.*\]/g);

    const ProductStockModel = modelConstructor.extend(ProductService.BasicProductModel, {
        id: "product_stock",
        base_component_id: "stock",
        dataResponseHandler: dataResponseHandler,
        applyBasicObjectDetails: applyBasicObjectDetails,
        isValidAcquiredObject: isValidAcquiredObject,
        applyItemHandler: applyItemHandler,
        handleSharedProducts: handleSharedProducts,
        use_image_zoom: false
    });

    this.factory = new ProductService.BasicProductModelFactory({
        birth: function (values) {
            return new ProductStockModel(values);
        },

        validVariationPointers: function (variationIDs) {
            return ['request_range_id', 'site_range_id', 'colour_id', 'style_id', 'parent_category_group_id', 'parent_category_id', 'product_id'];
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const parentCategoryID = model.parent_category_id;

        const isPromotionalStock = [
            "promotional_printed",
            "promotional_clicbox",
            "promotional_misc",
            "promotional_valore",
            "promotional_firbeck",
            "promotional_ora",
            "promotional_jayline",
            "promotional_wilton",
            "promotional_bella",
            "promotional_zurfiz",
            "promotional_thornbury",
            "promotional_hadley",
            "promotional_lacarre",
            "promotional_timber"
        ].includes(parentCategoryID);


        const useImageZoom = ['cabinet_interior', 'cutlery'].includes(parentCategoryID);

        siteHelper.applyValues(model, {
            use_image_zoom: useImageZoom,
            is_promotional_stock: isPromotionalStock
        });
    }


    function applyBasicObjectDetails(acquiredObject) {
        this.super(acquiredObject);
        const requestRangeID = acquiredObject.range;

        if (acquiredObject.tags.includes("curved") && !acquiredObject.tags.includes("curved_accessory") && !acquiredObject.tags.includes("curved_door")) {
            acquiredObject.tags.push("curved_door");
        }
        if (requestRangeID === "pronto" && acquiredObject.tags.includes("general") && !acquiredObject.tags.includes("polish")) {
            acquiredObject.tags.push("polish")
        }
        if (acquiredObject.tags.includes("gola") && !acquiredObject.tags.includes("handleless_rail")) {
            acquiredObject.tags.push("handleless_rail");
        }
        if (acquiredObject.tags.includes("dentilrail") && !acquiredObject.tags.includes("dentalrail")) {
            acquiredObject.tags.push("dentalrail");
        }
    }


    function isValidAcquiredObject(acquiredObject) {

        if (!this.super(acquiredObject)) {
            return false;
        }

        const model = this.root;
        if (!model.parent_category_cache) {
            return false;
        }

        if (acquiredObject.is_placeholder) {
            return true;
        }

        const tags = acquiredObject.tags ? acquiredObject.tags : [];

        if(acquiredObject.id.toUpperCase() === "*SC-AHGKEB160BA") {
            return false;
        }

        if (model.parent_category_cache.product_codes && !model.parent_category_cache.product_codes.includes(acquiredObject.id)) {
            return false;
        }

        const colourID = model.colour_id;
        const styleID = model.style_id;

        if (colourID && acquiredObject.colour_exceptions && acquiredObject.colour_exceptions[colourID]) {
            return false;
        }

        if (styleID && acquiredObject.style_exceptions && acquiredObject.style_exceptions[styleID]) {
            return false;
        }


        if (tags.indexOf("blossom_avenue_only") !== -1) {
            if (!$rootScope.model.account.is_blossom_customer) {
                return false;
            }
        }
        const parentCategoryGroupTypeID = acquiredObject.parent_category_group_type_id
        const parentCategoryGroupID = acquiredObject.parent_category_group_id
        const parentCategoryID = acquiredObject.parent_category_id
        if(parentCategoryGroupTypeID === "promotional"){

            const isPrinted = tags.includes("printed");
            let isSample = false;
            for(let tag of tags){
                if(["bellasampledoor", "prontosampledoor", "sampledoor", "sampledoorpack", "zurfizsampledoor"].includes(tag)){
                    isSample = true;
                    break;
                }
            }
            const isSwatch = tags.includes("swatch");
            const isOther = !isPrinted && !isSample && !isSwatch;
            if(parentCategoryGroupID === "promotional_printed" && !isPrinted){
                return false;
            }
            if(parentCategoryGroupID === "promotional_sample" && !isSample){
                return false;
            }
            if(parentCategoryGroupID === "promotional_swatch" && !isSwatch){
                return false;
            }
            if(parentCategoryGroupID === "promotional_other" && !isOther){
                return false;
            }
            if(tags.includes("misc") && parentCategoryID !== "promotional_misc") {
                return false;
            }
        }

        return true;
    }

    function applyItemHandler(product) {
        this.super(product);

        const model = this.root;

        product.limited_stock = product.limited_stock || product.tags.indexOf('limited_stock') !== -1;
        product.promote_new = product.promote_new || product.tags.indexOf('promote_new') !== -1;
        product.coming_soon = product.coming_soon || product.tags.indexOf('coming_soon') !== -1;
        product.back_soon = product.back_soon || product.tags.indexOf('back_soon') !== -1;
        product.prominent_disabled = product.coming_soon || product.back_soon;

        product.readable_api_code = product.api_code ? product.api_code.replace("*SC-", '') : "";
        product.readable_description = product.description ? product.description.replace(regexSquareBrackets, '') : "";
        product.quantity = 1;
        product.drill_0 = "";
        product.drill_1 = "";
        product.drill_2 = "";
        product.drill_3 = "";
        product.width = "";
        product.height = "";
        product.length = "";
        product.group_name = product.name;

        if (product.width && isNaN(product.width)) {
            product.width = 0;
        }
        if (product.height && isNaN(product.height)) {
            product.height = 0;
        }
        if(product.parent_category_id === "promotional_zurfiz"){
            product.request_range_id = "bella";
        }

        siteHelper.applyValues(product, {
            use_image_zoom: model.use_image_zoom,
            option_layout: "list",
            collectImageParams: function () {
                const params = this.super();

                params.image_type_id = "product";
                params.site_range_id = "bella";
                params.api_code = "stock";
                params.product_code = product.api_code;
                params.width = 250;
                params.height = 250;

                return params;
            },
            finalPrice: function () {
                return finalPrice(product);
            },
        });

        product.hinge_hole_options = $rootScope.service.product.getHingeHoleOptions(product);

        if (product.out_of_stock_message) {
            product.no_atc = true;
        }

        if (product.out_of_stock_message) {//we may sometimes get an 'out_of_stock_message' that matches a 'notice' being sent
            product.notice = product.out_of_stock_message;
        }
        //This is only used by lacarre, and when I submit, the API says its is disabled . May be better getting rid
        if (product.jpull) {
            product.jpull_position = {
                value: "top",
                options: [
                    {
                        id: "top",
                        name: "Top"
                    },
                    {
                        id: "bottom",
                        name: "Bottom"
                    }
                ]
            };
        }

        product.allow_zero_value = model.is_promotional_stock;
    }

    function handleSharedProducts() {
        const handlelessRailTag = "handlessrail";
        const products = this.root.choiceList();
        const handlelessRailProducts = [];
        for (let i = 0; i < products.length; i++) {
            const product = products[i];
            if (product.tags) {
                for (let j = 0; j < product.tags.length; j++) {
                    if (product.tags[j] === handlelessRailTag) {
                        handlelessRailProducts.push(product);
                        break
                    }
                }
            }
        }

        if (handlelessRailProducts.length > 0) {
            handleHandlelessRail(this.root, handlelessRailProducts);
        }

    }


    function handleHandlelessRail(model, products) {
        let i, j, sharedProduct, colourID, product;
        const handlelessRailColours = [
            {
                id: 'brushed_aluminium',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-brushed-aluminium.jpg',
                name: 'Brushed Aluminium'
            }, {
                id: 'aluminium',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-brushed-aluminium.jpg',
                name: 'Aluminium'
            }, {
                id: 'brushed_brass',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-brushed-brass.jpg',
                name: 'Brushed Brass'
            }, {
                id: 'brass',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-brushed-brass.jpg',
                name: 'Brass'
            }, {
                id: 'brushed_copper',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-brushed-copper.jpg',
                name: 'Brushed Copper'
            }, {
                id: 'copper',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-brushed-copper.jpg',
                name: 'Copper'
            }, {
                id: 'matt_black',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-matt-black.jpg',
                name: 'Matt Black'
            }, {
                id: 'matt_graphite',
                img_src: 'img/browse/option/handleless-rail/handleless-rail-matt-graphite.jpg',
                name: 'Matt Graphite'
            }
        ]

        const sharedProducts = {};
        const sharedProductList = [];
        for (i = 0; i < products.length; i++) {
            product = products[i];
            const tagsObject = {}
            for (j = 0; j < product.tags.length; j++) {
                const tag = product.tags[j];
                tagsObject[tag] = true;
            }

            let foundColourID = null;

            let colourCount = 0;
            let productColourDetails = null;
            for (j = 0; j < handlelessRailColours.length; j++) {
                const colourDetails = handlelessRailColours[j];
                colourID = colourDetails.id;
                if (tagsObject[colourID]) {
                    foundColourID = colourID;
                    colourCount++;
                    productColourDetails = colourDetails;
                }
            }
            const isShared = colourCount === 1;
            if (!isShared) {
                sharedProductList.push(product)
                sharedProducts[product.id] = product
            } else {
                const sharedProductID = product.api_code.substring(5).toUpperCase();
                sharedProduct = sharedProducts[sharedProductID];
                if (!sharedProduct) {
                    const sharedAcquiredObject = {
                        id: sharedProductID,
                        shared_product_id: sharedProductID,
                        sub_products: {},
                        sub_product_list: [],
                        current_sub_product_id: null
                    }
                    model.applyBasicObjectDetails(sharedAcquiredObject);
                    sharedProduct = model.birthChoice(sharedAcquiredObject);
                    sharedProductList.push(sharedProduct)
                    sharedProducts[sharedProduct.id] = sharedProduct
                    model.applyAcquiredChoice(sharedProduct);
                    siteHelper.applyValues(sharedProduct, {
                        activeSubProduct: function () {
                            return this.root.current_sub_product_id ? this.root.sub_products[this.root.current_sub_product_id] : null;
                        },
                        selectSubProduct: function (subProductID, refreshSubProductRequired) {
                            this.root.current_sub_product_id = subProductID;
                            if (refreshSubProductRequired) {
                                this.root.refresh_sub_product_required = true;
                            }
                        }
                    });
                }
                product.select_id = productColourDetails.id;
                product.select_img_src = productColourDetails.img_src;
                product.select_name = productColourDetails.name;
                sharedProduct.sub_products[foundColourID] = product;
            }
        }

        for (i = 0; i < sharedProductList.length; i++) {
            sharedProduct = sharedProductList[i];
            if (!sharedProduct.shared_product_id) {
                continue;
            }
            for (j = 0; j < handlelessRailColours.length; j++) {
                colourID = handlelessRailColours[j].id;
                if (sharedProduct.sub_products[colourID]) {
                    sharedProduct.sub_product_list.push(sharedProduct.sub_products[colourID]);
                    if (!sharedProduct.current_sub_product_id) {
                        sharedProduct.current_sub_product_id = colourID;
                    }
                }
            }
            if (sharedProduct.sub_product_list.length === 1) {
                product = sharedProduct.sub_product_list[0];
                sharedProductList[i] = product;
                delete sharedProducts[sharedProduct.id];
                sharedProducts[product.id] = product
                continue;
            }
            const activeSubProduct = sharedProduct.activeSubProduct();
            if (!activeSubProduct || activeSubProduct === sharedProduct) {
                delete sharedProducts[sharedProduct.id];
                sharedProductList.splice(i, 1);
                i--;
            } else {
                sharedProduct.sort_index = activeSubProduct.hasOwnProperty('sort_index') ? activeSubProduct.sort_index : Number.MAX_SAFE_INTEGER;
            }
        }

        model.shared_products = {
            products: sharedProducts,
            list: sharedProductList
        }
    }

    function dataResponseHandler(data) {
        return data.products ? data.products : [];
    }

    function finalPrice(product) {
        let totalPrice = 0;

        if (product.requires_width && product.requires_height) {
            if (product.width && product.height) {
                totalPrice = ((product.width * product.height) * product.base_price) / 1000000;
            }
        } else if (product.requires_length && product.requires_depth) {
            if (product.length && product.depth) {
                totalPrice = ((product.length * product.depth) * product.base_price) / 1000000;
            }
        } else if (product.requires_length) {
            if (product.length) {
                totalPrice = (product.base_price / 1000) * product.length;
            }
        } else {
            totalPrice = product.base_price;
        }

        if (totalPrice === 0) {
            return 0;
        }

        let colorSurcharge = 0;

        if (['zurfiz', 'valore'].includes(product.range)) {
            if (product.apply_colour_surcharge) {
                colorSurcharge = ($rootScope.navigation_model.state_values.colour_surcharge / 100) * totalPrice;
            }
        }

        totalPrice = totalPrice + colorSurcharge;

        return $rootScope.service.product.appliedMinimumDiscountPrice(product, totalPrice);
    }

}]);